<template>
  <main class="main-content">
    <main-hero />
    <main-todays-picks />
    <main-trending-countries />
    <main-trust-strip />
  </main>
</template>

<script setup lang="ts">
import { filtersStore } from "~/store/search_filters";
import { updateCommonSeo } from "~/services/SEO/updateCommonSeo";

const mainHero = defineAsyncComponent(
  () => import("~/components/Main/Hero.vue")
);
const mainTrustStrip = defineAsyncComponent(
  () => import("~/components/Main/TrustStrip.vue")
);
const mainTodaysPicks = defineAsyncComponent(
  () => import("~/components/Main/TodaysPicks.vue")
);
const mainTrendingCountries = defineAsyncComponent(
  () => import("~/components/Main/TrendingCountries.vue")
);

definePageMeta({
  layout: "default",
});

updateCommonSeo();

const useFiltersStore = filtersStore();

onMounted(async () => {
  if (!useFiltersStore.currentStats) {
    await useFiltersStore.updateEstateFilters(true, {});
  }
});
</script>

<style scoped lang="scss">
.main-content {
  width: 100%;
  padding: 32px 0 96px;
  display: flex;
  flex-direction: column;
  gap: 96px;
}

@media (max-width: 75rem) {
  .main-content {
    padding: 16px 0 64px;
    gap: 64px;
  }
}
</style>
